import '@babel/polyfill';
import $ from 'jquery';
import 'jquery-mask-plugin';
import { init } from '@sentry/browser';
import 'formBuilder/dist/form-render.min.js';
import '../js/custom-fields/choice-buttons';
import '../sass/embed.scss';
import { customFields, customTemplates } from './custom-fields.js';
import './multi-step.js';
import { getDeviceWidth, getQueryString, getGCU, getClientId } from './gcu-hidden-fields';

$.fn.reduce = [].reduce;

if (window.SENTRY_DSN) {
    init({
        dsn: window.SENTRY_DSN,
        ignoreUrls: [
            /player\.vimeo\.com\/api\/player\.js/i,
            /graph\.facebook\.com/i,
            /connect\.facebook\.net\/en_US\/all\.js/i,
            /extensions\//i,
            /^chrome:\/\//i,
            /127\.0\.0\.1:4001\/isrunning/i,
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
        ignoreErrors: [
            "Cannot read property 'top' of null",
            "Can't find variable: lp",
            "Can't find variable: hj",
            "'hj' is undefined",
            "'jQuery' is undefined",
            "'$' is undefined",
            'Syntax error, unrecognized expression: a[href^=#]',
            'The player element passed isnÃÂÃÂÃÂÃÂ¢ÃÂÃÂÃÂÃÂÃÂÃÂÃÂÃÂt a Vimeo embed.',
            "evaluating 'ceCurrentVideo.currentTime'",
            "Object doesn't support property or method 'find'",
            "$( $(this).attr('href') ).offset().top')",
            'a.split is not a function',
            "Can't find variable: $",
            'undefined is not a function',
            "undefined is not a function (near '...}).find(function (c) {...')",
            "Can't find variable: jQuery",
            'document.cookie.split(...).map(...).find is not a function',
            'document.querySelectorAll(...).forEach is not a function',
            "null is not an object (evaluating '$( $(this).attr('href') ).offset().top’)",
            "e.dn is not a function. (In 'e.dn(o)', 'e.dn' is undefined)",
            'cookieObj.find is not a function',
        ],
    });
}

const modalHtml = `<div id="fsm-modal"><div class="fsm-modal-content"><div class="fsm-modal-close">&times;</div><div class="fsm-modal-body"></div></div></div></div>`;

$(() => {
    const formbuilderFields = window.FSM_BUILDER_FORM_DATA;

    // First check if we are on the form styling page
    // Otherwise, just use the first form on the page
    let form = $('#style-editing-form').first();
    let loader = $('#fsm-loader').first();
    if (form.length == 0) form = $('form').first();

    const hiddens = form.find('input[type=hidden]');

    form.formRender({
        dataType: 'json',
        formData: formbuilderFields.form_fields,
        fields: customFields,
        templates: customTemplates,
    });
    form.append();
    form.append(hiddens);
    form.css({
        opacity: 1,
        visibility: 'visible',
    });
    if (loader.length) loader.css({ display: 'none' });

    // GCU fields
    var gcuInput = $('#gcu');
    var queryInput = $('#query_string');
    var deviceInput = $('#Device');
    var clientInput = $('#client_id');
    if (gcuInput) gcuInput.val(getGCU());
    if (queryInput) queryInput.val(getQueryString());
    if (deviceInput) deviceInput.val(getDeviceWidth());
    if (clientInput) clientInput.val(getClientId());

    const renderedForm = form.find('.rendered-form');
    renderedForm.addClass('msf-content');

    // Multi page functionality
    const dividers = renderedForm.find('.formbuilder-pageBreak');
    const groupedFormFields = renderedForm.children().reduce(
        (all, cur) => {
            if ($(cur).hasClass('formbuilder-pageBreak')) {
                all.push([]);
            } else {
                all[all.length - 1].push(cur);
            }

            return all;
        },
        [[]],
    );
    groupedFormFields.map((group, i) => {
        const newDom = $(`<div class="msf-view"></div>`).append(group);
        renderedForm.append(newDom);
    });
    dividers.remove();
    form.multiStepForm();
    form.removeAttr('novalidate');

    // Put half class on the correct elements
    var half = $('.half');
    half.each((index, element) => {
        if ($(element).is('p')) {
            $(element).removeClass('half');
            $(element).parent().addClass('half');
        } else {
            $(element).removeClass('half');
            $(element).parents('.form-group').addClass('half');
        }
    });

    // Force first option of selects to be disabled
    var selects = $('select.form-control');
    selects.each((index, select) => {
        if (select.childNodes[0].disabled) {
            select.childNodes[0].setAttribute('disabled', true);
            select.childNodes[0].value = '';
        }
    });

    var mobileNumberInput = $('input.mobile-number-only');
    var zips = $('input[name="Zip"]');

    zips.each((i, el) => {
        $(el).attr('inputmode', 'decimal');
        $(el).attr('pattern', '[0-9]*');
    });

    mobileNumberInput.each((i, el) => {
        $(el).attr('inputmode', 'decimal');
        $(el).attr('pattern', '[0-9]*');
    });

    // Add validation to phone numbers
    var phoneFields = $('input[type="tel"]');
    phoneFields.attr('pattern', '^(\\+?1[ -]?)?\\(?[2-9]\\d\\d\\)?[ -]?[2-9]\\d\\d[ -]?\\d{4}$');

    for (let phoneField of phoneFields) {
        $(phoneField).mask('(000) 000-0000');
    }

    // Address autocomplete
    var addressFields = $('.address-autocomplete');
    for (let addressField of addressFields) {
        var currentAddress = '';
        addressField.addEventListener('blur', () => {
            addressField.value = currentAddress;
        });
        var autocomplete = new google.maps.places.Autocomplete(addressField, {
            componentRestrictions: { country: ['us', 'ca'] },
            fields: ['formatted_address'],
            types: ['address'],
        });
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            let address = place.formatted_address;
            if (address) {
                addressField.value = address;
                currentAddress = address;
            }
        });
    }

    // Reset the form on submit
    if (form) {
        form.on('reset', () => form.setActiveView(0));
    }
    // Disclaimer listeners
    $('[class^="disclaimer-"]').each((index, element) => {
        const disclaimer = $(element);
        const disclaimerFieldClass =
            '.field-' +
            disclaimer
                .attr('class')
                .split(/\s+/)
                .filter((c) => c.indexOf('disclaimer-' == 0))[0]
                .replace('disclaimer-', '');
        const fieldForDisclaimer = $(disclaimerFieldClass);
        fieldForDisclaimer.on('fsm-hide', () => disclaimer.trigger('fsm-hide'));
        fieldForDisclaimer.on('fsm-show', () => disclaimer.trigger('fsm-show'));
    });

    // Custom event listeners
    $(document).on('fsm-hide', (e) => {
        var inputContainer = $(e.target);
        var input = inputContainer.find('input');
        inputContainer.addClass('hide');
        if (input.prop('required') == true) {
            input.addClass('hidden-required');
            input.removeAttr('required');
        }
        form.views.eq(form.currentIndex).show();
    });
    $(document).on('fsm-show', (e) => {
        var inputContainer = $(e.target);
        var input = inputContainer.find('input');
        inputContainer.removeClass('hide');
        if (input.hasClass('hidden-required')) {
            input.removeClass('hidden-required');
            input.attr('required', 'required');
        }
        form.views.eq(form.currentIndex).show();
    });

    function getCurrentStep() {
        return form.currentIndex;
    }
    function hideStepContaining(element) {
        element.closest('.msf-view').addClass('hide-step');
    }
    function showStepContaining(element) {
        element.closest('.msf-view').removeClass('hide-step');
    }

    // Modal rendering and helpers
    $('body').append(modalHtml);
    function openModal(html) {
        const modal = $('#fsm-modal');
        $('.fsm-modal-body', modal).html(html);
        modal.show();
    }

    function closeModal() {
        const modal = $('#fsm-modal');
        $('.fsm-modal-body', modal).html();
        modal.hide();
    }

    const modal = $('#fsm-modal');
    $(modal).on('click', () => closeModal());
    $('.fsm-modal-close', modal).on('click', () => closeModal());
    $('.fsm-modal-content', modal).on('click', (e) => e.stopPropagation());

    //this doens't work via jquery. Checks if the invlalid trigger has happened on the inputs, and hides the bubble
    document.addEventListener(
        'invalid',
        (function () {
            return function (e) {
                e.preventDefault();
            };
        })(),
        true,
    );

    // Initialize logic
    window.FSM_BUILDER_CUSTOM_SCRIPTS(
        $,
        form.setActiveView,
        getCurrentStep,
        hideStepContaining,
        showStepContaining,
        openModal,
        closeModal,
    );
});
